import cn from 'clsx'

import React from 'react'
export type Props = {
  className?: string
  children?: React.ReactNode
}
export const Footer = (props: Props): React.ReactElement<'header'> => {
  const { className, children } = props
  return <header className={cn('Panel_Footer', className)}>{children}</header>
}
export default Footer
